import { render, staticRenderFns } from "./SeccionOcultable.vue?vue&type=template&id=5e5862b4&scoped=true&"
import script from "./SeccionOcultable.vue?vue&type=script&lang=js&"
export * from "./SeccionOcultable.vue?vue&type=script&lang=js&"
import style0 from "./SeccionOcultable.vue?vue&type=style&index=0&id=5e5862b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5862b4",
  null
  
)

export default component.exports